import Splide from '@splidejs/splide';

export const initCategoryBlock = () => {
  /**
   * Splide slider on mobile
   */
  const categoryPuffBlock = document.querySelector(".category-puff-block") as HTMLElement;
  if (categoryPuffBlock) {
    new Splide( '.splide-category-puff', {
      perPage: 1,
      gap: 16,
      lazyLoad: 'nearby',
      label: 'Kategoripuffar',
      pagination: false,
      focus: 0,
      omitEnd: true,
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
      },
      mediaQuery: 'min',
      breakpoints:  {
        1430: {
          destroy: true,
        },
      }
    }).mount();
  
  
    // const updatePaginationText = () => {
    //   const splidePaginationPages = document.querySelectorAll(".splide__pagination__page");
    //   const maxNumber = splidePaginationPages.length;
    
    //   splidePaginationPages.forEach((page, index) => {
    //    page.textContent = `${index + 1} / ${maxNumber} slides`;
    //   });
    // };

    // const paginationElement = document.querySelector('.splide__pagination');
    // const paginationArrows = document.querySelector('.splide__arrows');

    // const hideArrows = () => {
    //   if (paginationArrows) {
    //     paginationArrows.classList.toggle("hide");
    //   }
    // }

    // if (paginationElement && getComputedStyle(paginationElement).display !== 'none') {
    //   updatePaginationText();
    // } else {
    //   hideArrows();
    //   window.addEventListener('resize', hideArrows);
    // }
    
    // window.addEventListener("resize", updatePaginationText);
  }
}